<template>
  <Multiline.Wrapper ref="wrapperRef" class="relative">
    <Multiline.Text :id="index.toString()" v-model="value" placeholder="Key" />

    <Multiline.Delete @click="emit('remove')" />

    <DropIndicator :edge="draggable.edge" gap="4px" />
  </Multiline.Wrapper>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { useReorderableListItem } from "@/lib/pragmatic-dnd";
import DropIndicator from "@/lib/pragmatic-dnd/DropIndicator.vue";

import Multiline from "../Multiline";

const value = defineModel<string>({ default: "" });

const emit = defineEmits(["remove"]);

const props = defineProps<{
  index: number;
}>();

const wrapperRef = ref<any>();

const draggable = useReorderableListItem({
  element: () => wrapperRef.value?.$el,
  index: () => props.index,
});
</script>
